import React from "react";

export const Logo = ({ extraClasses }) => (
  <svg width="169px" height="99px" viewBox="0 0 337 192" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="logo-fp" fillRule="nonzero">
        <path
          d="M185.4,41.8 L172.1,54.2 C172.1,54.2 168.5,50.3 175.6,43.7 C179,40.5 184.6,39.2 186.9,37.9 C189.2,36.6 191.4,35.4 191.4,35.4 C191.4,35.4 189.9,37.7 187.4,43.5 C186.6,45.4 185.3,49 183.2,51.3 C176.1,58.6 172.8,54.8 172.8,54.8 L185.4,41.8"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M173.5,27.8 L169.6,43.7 C169.6,43.7 164.9,42.6 167,34.1 C168,30 171.5,26.3 172.6,24.2 C173.7,22.1 174.8,20 174.8,20 C174.8,20 174.8,22.5 175.8,28.1 C176.1,30 177,33.3 176.5,36.1 C174.8,45.1 170.4,43.9 170.4,43.9 L173.5,27.8"
          id="Shape"
          fill="#007A61"
        />
        <path
          d="M158.3,40.2 L166.4,56.4 C166.4,56.4 161.6,58.8 157.3,50.1 C155.2,46 155.5,40.2 154.9,37.7 C154.3,35.1 153.7,32.6 153.7,32.6 C153.7,32.6 155.5,34.6 160.3,38.7 C161.9,40 165,42.2 166.6,45 C171.6,53.9 167.1,55.9 167.1,55.9 L158.3,40.2"
          id="Shape"
          fill="#64826F"
        />
        <path
          d="M141.2,61 L159.3,61.5 C159.3,61.5 159.2,66.8 149.5,66.6 C144.9,66.5 140,63.5 137.4,62.8 C134.9,62.1 132.4,61.4 132.4,61.4 C132.4,61.4 135.1,60.8 140.9,58.4 C142.8,57.6 146.2,55.9 149.4,55.8 C159.6,55.6 159.3,60.5 159.3,60.5 L141.2,61"
          id="Shape"
          fill="#006E59"
        />
        <path
          d="M161,77.7 L167.6,60.8 C167.6,60.8 172.6,62.7 169,71.7 C167.3,76 162.9,79.6 161.3,81.8 C159.8,83.9 158.3,86.1 158.3,86.1 C158.3,86.1 158.6,83.4 158.4,77.1 C158.3,75 157.9,71.2 158.9,68.3 C162.1,58.7 166.7,60.6 166.7,60.6 L161,77.7"
          id="Shape"
          fill="#64826F"
        />
        <path
          d="M186.7,67.6 L170.9,58.7 C170.9,58.7 173.5,54 181.9,58.8 C185.9,61.1 188.9,66 190.8,67.8 C192.7,69.6 194.6,71.4 194.6,71.4 C194.6,71.4 192,70.7 185.7,70 C183.6,69.8 179.8,69.7 177,68.3 C167.9,63.7 170.5,59.5 170.5,59.5 L186.7,67.6"
          id="Shape"
          fill="#8DC9A4"
        />
        <path
          d="M187.9,26.1 L180,35.6 C180,35.6 177.2,33.3 181.4,28.2 C183.4,25.8 187.1,24.4 188.6,23.3 C190.1,22.2 191.5,21.2 191.5,21.2 C191.5,21.2 190.7,22.9 189.5,27 C189.1,28.4 188.6,30.9 187.3,32.6 C183.1,38.1 180.6,35.9 180.6,35.9 L187.9,26.1"
          id="Shape"
          fill="#8DC9A4"
        />
        <path
          d="M182.1,14.3 L180.6,24.3 C180.6,24.3 177.7,23.9 178.5,18.5 C178.9,15.9 180.9,13.4 181.4,12.1 C182,10.7 182.5,9.4 182.5,9.4 C182.5,9.4 182.7,10.9 183.5,14.3 C183.8,15.4 184.5,17.4 184.3,19.2 C183.7,24.8 181,24.3 181,24.3 L182.1,14.3"
          id="Shape"
          fill="#58B680"
        />
        <path
          d="M155.4,7.8 L155.7,17.9 C155.7,17.9 152.7,18 152.6,12.6 C152.5,10 154,7.2 154.4,5.8 C154.7,4.4 155,3 155,3 C155,3 155.4,4.5 156.9,7.6 C157.4,8.7 158.4,10.5 158.6,12.2 C159,17.8 156.2,17.8 156.2,17.8 L155.4,7.8"
          id="Shape"
          fill="#006E59"
        />
        <path
          d="M198.1,25.9 L190.6,32.6 C190.6,32.6 188.6,30.4 192.7,26.8 C194.6,25.1 197.8,24.4 199.1,23.7 C200.4,23 201.7,22.3 201.7,22.3 C201.7,22.3 200.9,23.6 199.4,26.7 C198.9,27.8 198.2,29.7 196.9,31 C192.9,35 191.1,32.8 191.1,32.8 L198.1,25.9"
          id="Shape"
          fill="#3EA864"
        />
        <path
          d="M198.3,15.3 L193.8,21.8 C193.8,21.8 191.9,20.5 194.3,17 C195.5,15.3 197.7,14.3 198.6,13.5 C199.5,12.7 200.3,12 200.3,12 C200.3,12 199.9,13.1 199.3,15.8 C199.1,16.7 198.9,18.3 198.2,19.5 C195.8,23.3 194.1,22 194.1,22 L198.3,15.3"
          id="Shape"
          fill="#006E59"
        />
        <path
          d="M192.2,12 L186.1,17.1 C186.1,17.1 184.6,15.3 187.8,12.6 C189.3,11.3 191.8,10.8 192.8,10.3 C193.8,9.8 194.8,9.3 194.8,9.3 C194.8,9.3 194.1,10.3 192.9,12.7 C192.5,13.5 191.9,15.1 190.9,16 C187.7,19 186.3,17.3 186.3,17.3 L192.2,12"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M209.9,25.4 L202.2,27.4 C202.2,27.4 201.6,25.1 205.7,24.1 C207.7,23.6 210.1,24.2 211.2,24.2 C212.3,24.2 213.5,24.2 213.5,24.2 C213.5,24.2 212.5,24.8 210.3,26.5 C209.6,27.1 208.4,28.2 207.1,28.6 C202.9,29.9 202.4,27.8 202.4,27.8 L209.9,25.4"
          id="Shape"
          fill="#007A61"
        />
        <path
          d="M140.9,41.6 L153.6,51.9 C153.6,51.9 150.6,55.6 143.8,50.1 C140.6,47.5 138.7,42.6 137.2,40.7 C135.8,38.8 134.4,37 134.4,37 C134.4,37 136.6,38 142.1,39.6 C143.9,40.1 147.3,40.7 149.6,42.4 C157,47.8 154,51.2 154,51.2 L140.9,41.6"
          id="Shape"
          fill="#006139"
        />
        <path
          d="M145.5,27.9 L150.7,39.2 C150.7,39.2 147.4,40.7 144.6,34.7 C143.3,31.8 143.6,27.9 143.3,26.1 C143,24.3 142.6,22.6 142.6,22.6 C142.6,22.6 143.8,24 147,26.9 C148.1,27.9 150.1,29.4 151.1,31.3 C154.3,37.5 151.2,38.8 151.2,38.8 L145.5,27.9"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M131.1,51.4 L143,54.9 C143,54.9 142,58.4 135.6,56.5 C132.6,55.6 129.8,52.8 128.3,51.9 C126.8,51 125.2,50.1 125.2,50.1 C125.2,50.1 127.1,50.2 131.3,49.6 C132.7,49.4 135.3,48.9 137.3,49.4 C144,51 143,54.3 143,54.3 L131.1,51.4"
          id="Shape"
          fill="#58B680"
        />
        <path
          d="M132.4,28.1 L140.8,33.8 C140.8,33.8 139.1,36.3 134.7,33.2 C132.6,31.8 131.1,28.9 130.2,27.8 C129.2,26.7 128.2,25.7 128.2,25.7 C128.2,25.7 129.6,26.2 133.1,26.9 C134.2,27.1 136.4,27.3 137.8,28.2 C142.6,31.1 141,33.4 141,33.4 L132.4,28.1"
          id="Shape"
          fill="#8DC9A4"
        />
        <path
          d="M126.8,40.7 L135.6,45.6 C135.6,45.6 134.2,48.2 129.4,45.5 C127.1,44.2 125.5,41.5 124.4,40.5 C123.3,39.5 122.3,38.5 122.3,38.5 C122.3,38.5 123.8,38.9 127.3,39.3 C128.5,39.4 130.6,39.5 132.1,40.2 C137.2,42.7 135.7,45.1 135.7,45.1 L126.8,40.7"
          id="Shape"
          fill="#3EA864"
        />
        <path
          d="M149.7,18.6 L152.5,28.3 C152.5,28.3 149.7,29.1 148.1,24 C147.4,21.5 148.1,18.4 148,16.9 C147.9,15.4 147.9,14 147.9,14 C147.9,14 148.7,15.3 150.9,18 C151.6,18.9 153.1,20.4 153.7,22.1 C155.6,27.5 152.9,28.1 152.9,28.1 L149.7,18.6"
          id="Shape"
          fill="#8DC9A4"
        />
        <path
          d="M140.9,12.6 L144.8,19.5 C144.8,19.5 142.8,20.7 140.7,17 C139.7,15.2 139.7,12.7 139.4,11.6 C139.1,10.5 138.8,9.4 138.8,9.4 C138.8,9.4 139.6,10.3 141.8,11.9 C142.5,12.5 143.9,13.3 144.7,14.5 C147.1,18.2 145.2,19.3 145.2,19.3 L140.9,12.6"
          id="Shape"
          fill="#006139"
        />
        <path
          d="M123.7,29.5 L129.6,34.8 C129.6,34.8 128,36.5 124.9,33.7 C123.4,32.3 122.6,30 122,29 C121.4,28 120.7,27.1 120.7,27.1 C120.7,27.1 121.8,27.6 124.4,28.5 C125.3,28.8 126.9,29.2 127.9,30.1 C131.3,32.9 129.8,34.5 129.8,34.5 L123.7,29.5"
          id="Shape"
          fill="#58B680"
        />
        <path
          d="M118.8,42.2 L125.4,46.7 C125.4,46.7 124.1,48.6 120.6,46.2 C118.9,45.1 117.8,42.8 117.1,41.9 C116.3,41 115.6,40.2 115.6,40.2 C115.6,40.2 116.7,40.6 119.4,41.1 C120.3,41.3 122,41.4 123.1,42.2 C126.9,44.5 125.6,46.3 125.6,46.3 L118.8,42.2"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M117.2,52 L125.1,52.8 C125.1,52.8 124.9,55.1 120.7,54.7 C118.7,54.5 116.6,53 115.6,52.7 C114.5,52.3 113.5,51.9 113.5,51.9 C113.5,51.9 114.7,51.7 117.3,50.9 C118.2,50.6 119.7,50 121.1,50.1 C125.5,50.3 125.2,52.5 125.2,52.5 L117.2,52"
          id="Shape"
          fill="#64826F"
        />
        <path
          d="M134.7,18 L136.7,25.7 C136.7,25.7 134.4,26.3 133.4,22.2 C132.9,20.2 133.5,17.8 133.5,16.7 C133.5,15.5 133.5,14.4 133.5,14.4 C133.5,14.4 134.1,15.4 135.8,17.6 C136.4,18.3 137.5,19.5 137.9,20.8 C139.2,25 137.1,25.5 137.1,25.5 L134.7,18"
          id="Shape"
          fill="#64826F"
        />
        <path
          d="M178.8,5.9 L177.8,13.8 C177.8,13.8 175.5,13.5 176,9.3 C176.3,7.3 177.7,5.3 178.2,4.2 C178.6,3.1 179,2 179,2 C179,2 179.2,3.2 179.9,5.8 C180.2,6.7 180.8,8.2 180.7,9.6 C180.4,14 178.2,13.7 178.2,13.7 L178.8,5.9"
          id="Shape"
          fill="#64826F"
        />
        <path
          d="M178.1,85.5 L173.9,69.7 C173.9,69.7 178.5,68.4 180.8,76.9 C181.9,80.9 180.6,85.9 180.6,88.3 C180.6,90.7 180.7,93 180.7,93 C180.7,93 179.5,90.9 176,86.4 C174.8,84.9 172.5,82.4 171.6,79.7 C168.8,71 173.2,70 173.2,70 L178.1,85.5"
          id="Shape"
          fill="#58B680"
        />
        <path
          d="M166.3,93.9 L168.7,81.7 C168.7,81.7 172.3,82.4 171,88.9 C170.4,92 167.8,95 167.1,96.6 C166.3,98.2 165.6,99.8 165.6,99.8 C165.6,99.8 165.5,97.9 164.6,93.7 C164.3,92.3 163.5,89.8 163.8,87.7 C164.8,80.8 168.1,81.6 168.1,81.6 L166.3,93.9"
          id="Shape"
          fill="#58B680"
        />
        <path
          d="M177,101.5 L173.5,92 C173.5,92 176.3,91 178.1,96 C179,98.4 178.5,101.6 178.6,103 C178.8,104.5 178.9,105.9 178.9,105.9 C178.9,105.9 178,104.7 175.6,102.1 C174.8,101.3 173.2,99.8 172.5,98.2 C170.3,93 172.9,92.1 172.9,92.1 L177,101.5"
          id="Shape"
          fill="#006139"
        />
        <path
          d="M197.7,92.6 L192.1,84.2 C192.1,84.2 194.6,82.5 197.6,87 C199,89.1 199.3,92.3 199.8,93.7 C200.3,95.1 200.8,96.4 200.8,96.4 C200.8,96.4 199.7,95.4 196.7,93.5 C195.7,92.9 193.8,91.9 192.8,90.5 C189.4,85.9 191.8,84.5 191.8,84.5 L197.7,92.6"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M157.4,98.9 L160.8,89.4 C160.8,89.4 163.6,90.4 161.8,95.5 C160.9,97.9 158.5,100 157.7,101.2 C156.9,102.4 156.1,103.6 156.1,103.6 C156.1,103.6 156.2,102.1 156,98.6 C155.9,97.4 155.6,95.3 156.1,93.7 C157.7,88.3 160.3,89.3 160.3,89.3 L157.4,98.9"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M185.9,91.9 L185.6,81.8 C185.6,81.8 188.6,81.7 188.7,87.1 C188.8,89.7 187.3,92.5 187,93.9 C186.7,95.3 186.4,96.7 186.4,96.7 C186.4,96.7 186,95.2 184.5,92.1 C184,91 182.9,89.2 182.8,87.5 C182.4,81.9 185.1,81.9 185.1,81.9 L185.9,91.9"
          id="Shape"
          fill="#006E59"
        />
        <path
          d="M209.2,76.8 L199.5,74 C199.5,74 200.3,71.1 205.5,72.6 C208,73.3 210.2,75.6 211.5,76.3 C212.8,77 214,77.7 214,77.7 C214,77.7 212.5,77.7 209,78.1 C207.8,78.2 205.8,78.7 204.1,78.3 C198.6,77 199.4,74.4 199.4,74.4 L209.2,76.8"
          id="Shape"
          fill="#8DC9A4"
        />
        <path
          d="M161,109.1 L161.9,101.2 C161.9,101.2 164.2,101.4 163.8,105.7 C163.6,107.7 162.1,109.7 161.7,110.8 C161.3,111.9 160.9,112.9 160.9,112.9 C160.9,112.9 160.7,111.7 159.9,109.1 C159.6,108.2 159,106.7 159.1,105.3 C159.4,100.9 161.5,101.2 161.5,101.2 L161,109.1"
          id="Shape"
          fill="#64826F"
        />
        <path
          d="M182.5,104.7 L183.1,96.8 C183.1,96.8 185.4,97 185.1,101.2 C184.9,103.2 183.5,105.3 183.2,106.4 C182.8,107.5 182.5,108.6 182.5,108.6 C182.5,108.6 182.3,107.4 181.4,104.8 C181.1,103.9 180.4,102.4 180.5,101 C180.6,96.6 182.8,96.8 182.8,96.8 L182.5,104.7"
          id="Shape"
          fill="#58B680"
        />
        <path
          d="M169.2,108.3 L172.1,100.9 C172.1,100.9 174.3,101.7 172.7,105.7 C172,107.6 170,109.2 169.4,110.1 C168.7,111 168.1,112 168.1,112 C168.1,112 168.2,110.8 168.1,108.1 C168.1,107.2 167.9,105.5 168.3,104.2 C169.7,100 171.7,100.8 171.7,100.8 L169.2,108.3"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M194.3,101.9 L191.4,94.5 C191.4,94.5 193.6,93.6 195.1,97.6 C195.8,99.5 195.5,102 195.6,103.1 C195.8,104.2 195.9,105.4 195.9,105.4 C195.9,105.4 195.2,104.4 193.3,102.5 C192.7,101.8 191.4,100.8 190.8,99.5 C189,95.5 191,94.7 191,94.7 L194.3,101.9"
          id="Shape"
          fill="#8DC9A4"
        />
        <path
          d="M196.5,79.8 L185.4,74.3 C185.4,74.3 187,71 192.9,74 C195.7,75.4 197.9,78.6 199.3,79.8 C200.7,81 202,82.1 202,82.1 C202,82.1 200.2,81.7 195.9,81.5 C194.5,81.4 191.9,81.5 189.9,80.7 C183.5,77.9 185.1,74.9 185.1,74.9 L196.5,79.8"
          id="Shape"
          fill="#3EA864"
        />
        <path
          d="M206.4,90.5 L200.5,85.2 C200.5,85.2 202.1,83.5 205.2,86.3 C206.7,87.7 207.5,90 208.1,91 C208.7,92 209.4,92.9 209.4,92.9 C209.4,92.9 208.3,92.4 205.7,91.5 C204.8,91.2 203.2,90.8 202.2,89.9 C198.8,87.1 200.3,85.5 200.3,85.5 L206.4,90.5"
          id="Shape"
          fill="#006139"
        />
        <path
          d="M143.5,81.3 L155.5,70.2 C155.5,70.2 158.8,73.7 152.4,79.7 C149.3,82.5 144.3,83.7 142.2,84.9 C140.1,86 138.1,87.2 138.1,87.2 C138.1,87.2 139.4,85.1 141.7,79.9 C142.5,78.2 143.6,74.9 145.5,72.9 C151.9,66.3 154.9,69.7 154.9,69.7 L143.5,81.3"
          id="Shape"
          fill="#8DC9A4"
        />
        <path
          d="M131.5,74.5 L143.7,72.1 C143.7,72.1 144.4,75.7 137.9,77 C134.8,77.6 131.1,76.4 129.3,76.3 C127.5,76.2 125.7,76.1 125.7,76.1 C125.7,76.1 127.4,75.3 130.9,72.8 C132.1,72 134.1,70.3 136.2,69.8 C142.9,68.1 143.5,71.5 143.5,71.5 L131.5,74.5"
          id="Shape"
          fill="#006139"
        />
        <path
          d="M128.5,86.7 L136.4,80.4 C136.4,80.4 138.3,82.7 134,86.1 C132,87.7 128.8,88.2 127.5,88.8 C126.2,89.4 124.9,90 124.9,90 C124.9,90 125.8,88.8 127.5,85.7 C128.1,84.7 128.9,82.7 130.2,81.6 C134.5,77.9 136.1,80.1 136.1,80.1 L128.5,86.7"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M126.1,66.6 L136.2,66.2 C136.2,66.2 136.3,69.2 130.9,69.4 C128.3,69.5 125.5,68 124,67.7 C122.6,67.4 121.2,67.1 121.2,67.1 C121.2,67.1 122.7,66.7 125.8,65.2 C126.9,64.7 128.7,63.6 130.4,63.5 C136,63 136.1,65.8 136.1,65.8 L126.1,66.6"
          id="Shape"
          fill="#3EA864"
        />
        <path
          d="M122.3,59.5 L132.1,57.1 C132.1,57.1 132.8,60 127.6,61.3 C125.1,61.9 122,61 120.5,61 C119,61 117.6,61 117.6,61 C117.6,61 118.9,60.3 121.7,58.2 C122.6,57.5 124.2,56.1 125.9,55.6 C131.3,54 131.9,56.7 131.9,56.7 L122.3,59.5"
          id="Shape"
          fill="#006139"
        />
        <path
          d="M137.8,93.7 L146.6,88.7 C146.6,88.7 148.1,91.3 143.4,93.9 C141.2,95.2 138,95.2 136.5,95.6 C135.1,96 133.7,96.4 133.7,96.4 C133.7,96.4 134.8,95.3 136.9,92.5 C137.6,91.6 138.7,89.8 140.2,88.8 C145,85.8 146.3,88.2 146.3,88.2 L137.8,93.7"
          id="Shape"
          fill="#006139"
        />
        <path
          d="M119.2,73.6 L126.6,70.7 C126.6,70.7 127.5,72.9 123.5,74.4 C121.6,75.1 119.1,74.8 118,75 C116.9,75.2 115.7,75.3 115.7,75.3 C115.7,75.3 116.7,74.6 118.6,72.6 C119.2,72 120.3,70.7 121.6,70.1 C125.6,68.3 126.4,70.3 126.4,70.3 L119.2,73.6"
          id="Shape"
          fill="#006E59"
        />
        <path
          d="M130,92.1 L137.3,88.9 C137.3,88.9 138.2,91 134.3,92.7 C132.4,93.5 129.9,93.2 128.8,93.4 C127.7,93.6 126.6,93.8 126.6,93.8 C126.6,93.8 127.5,93.1 129.4,91.1 C130,90.4 131.1,89.1 132.3,88.5 C136.3,86.5 137.1,88.6 137.1,88.6 L130,92.1"
          id="Shape"
          fill="#007A61"
        />
        <path
          d="M121.4,80.8 L129.3,79.9 C129.3,79.9 129.6,82.2 125.4,82.7 C123.4,82.9 121.1,82 119.9,81.8 C118.8,81.7 117.6,81.5 117.6,81.5 C117.6,81.5 118.7,81.1 121.1,79.7 C121.9,79.2 123.2,78.3 124.6,78.1 C129,77.4 129.2,79.5 129.2,79.5 L121.4,80.8"
          id="Shape"
          fill="#8DC9A4"
        />
        <path
          d="M140.6,101.6 L145.8,95.6 C145.8,95.6 147.6,97.1 144.8,100.3 C143.5,101.8 141.1,102.7 140.2,103.4 C139.3,104.1 138.4,104.7 138.4,104.7 C138.4,104.7 138.9,103.6 139.7,101 C140,100.1 140.3,98.5 141.2,97.4 C143.9,93.9 145.5,95.4 145.5,95.4 L140.6,101.6"
          id="Shape"
          fill="#006E59"
        />
        <path
          d="M149.5,93.1 L155.1,82 C155.1,82 158.4,83.6 155.4,89.5 C154,92.3 150.7,94.5 149.5,95.9 C148.3,97.3 147.2,98.6 147.2,98.6 C147.2,98.6 147.6,96.8 147.9,92.5 C148,91.1 147.9,88.5 148.8,86.5 C151.6,80.2 154.6,81.8 154.6,81.8 L149.5,93.1"
          id="Shape"
          fill="#64826F"
        />
        <path
          d="M151.9,105.7 L152,97.8 C152,97.8 154.3,97.8 154.3,102.1 C154.3,104.1 153,106.3 152.7,107.4 C152.4,108.5 152.1,109.6 152.1,109.6 C152.1,109.6 151.8,108.4 150.7,105.9 C150.3,105.1 149.6,103.6 149.5,102.2 C149.3,97.8 151.5,97.9 151.5,97.9 L151.9,105.7"
          id="Shape"
          fill="#3EA864"
        />
        <path
          d="M171.1,14.8 L166,23.5 C166,23.5 163.4,22 166.2,17.3 C167.5,15.1 170.3,13.5 171.3,12.4 C172.3,11.4 173.3,10.3 173.3,10.3 C173.3,10.3 172.9,11.8 172.5,15.2 C172.4,16.4 172.3,18.5 171.5,20 C168.9,25 166.5,23.5 166.5,23.5 L171.1,14.8"
          id="Shape"
          fill="#64826F"
        />
        <path
          d="M206.2,32.7 L196.7,36.1 C196.7,36.1 195.7,33.3 200.8,31.5 C203.2,30.6 206.4,31.2 207.8,31 C209.3,30.9 210.7,30.7 210.7,30.7 C210.7,30.7 209.4,31.6 206.9,33.9 C206,34.7 204.6,36.3 203,36.9 C197.8,39.1 196.9,36.4 196.9,36.4 L206.2,32.7"
          id="Shape"
          fill="#006139"
        />
        <path
          d="M161.3,22.8 L162.4,35.2 C162.4,35.2 158.8,35.5 158.2,28.9 C157.9,25.7 159.5,22.2 159.8,20.4 C160.1,18.6 160.3,16.9 160.3,16.9 C160.3,16.9 160.9,18.7 163,22.4 C163.7,23.7 165.1,25.8 165.4,27.9 C166.4,34.8 163,35 163,35 L161.3,22.8"
          id="Shape"
          fill="#3EA864"
        />
        <path
          d="M171.5,4.4 L168.4,11.7 C168.4,11.7 166.3,10.8 167.9,6.9 C168.7,5 170.7,3.5 171.4,2.6 C172.1,1.7 172.8,0.8 172.8,0.8 C172.8,0.8 172.6,2 172.6,4.7 C172.6,5.6 172.7,7.3 172.3,8.6 C170.7,12.8 168.8,11.8 168.8,11.8 L171.5,4.4"
          id="Shape"
          fill="#007A61"
        />
        <path
          d="M162.1,8.3 L164.7,15.8 C164.7,15.8 162.5,16.6 161.1,12.6 C160.4,10.7 160.9,8.2 160.8,7.1 C160.7,6 160.6,4.8 160.6,4.8 C160.6,4.8 161.3,5.8 163.1,7.8 C163.7,8.5 164.9,9.6 165.4,10.9 C167.1,15 165,15.7 165,15.7 L162.1,8.3"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M199.7,55.5 L183.3,55.3 C183.3,55.3 183.4,50.5 192.1,50.6 C196.3,50.7 200.7,53.3 203,53.9 C205.3,54.5 207.6,55.1 207.6,55.1 C207.6,55.1 205.2,55.7 200,57.9 C198.3,58.6 195.2,60.2 192.4,60.3 C183.2,60.6 183.5,56.1 183.5,56.1 L199.7,55.5"
          id="Shape"
          fill="#3EA864"
        />
        <path
          d="M204.6,69.1 L193.5,63.5 C193.5,63.5 195.1,60.2 201,63.3 C203.8,64.7 206,68 207.3,69.2 C208.7,70.4 210,71.5 210,71.5 C210,71.5 208.2,71.1 203.9,70.8 C202.5,70.7 199.9,70.8 197.9,69.9 C191.6,67.1 193.2,64.1 193.2,64.1 L204.6,69.1"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M214.8,60.9 L204.7,61.7 C204.7,61.7 204.5,58.7 209.9,58.3 C212.5,58.1 215.4,59.5 216.8,59.7 C218.2,59.9 219.7,60.2 219.7,60.2 C219.7,60.2 218.3,60.7 215.2,62.3 C214.2,62.8 212.4,64 210.7,64.2 C205.1,64.9 205,62.1 205,62.1 L214.8,60.9"
          id="Shape"
          fill="#64826F"
        />
        <path
          d="M217.7,71 L211.3,66.2 C211.3,66.2 212.7,64.3 216.1,66.9 C217.7,68.1 218.7,70.4 219.5,71.3 C220.2,72.2 220.9,73.1 220.9,73.1 C220.9,73.1 219.8,72.7 217.1,72 C216.2,71.8 214.6,71.5 213.4,70.8 C209.7,68.3 211.1,66.6 211.1,66.6 L217.7,71"
          id="Shape"
          fill="#3EA864"
        />
        <path
          d="M220.8,54.3 L212.9,55.1 C212.9,55.1 212.7,52.8 216.9,52.4 C218.9,52.2 221.2,53.2 222.4,53.4 C223.5,53.6 224.7,53.7 224.7,53.7 C224.7,53.7 223.6,54.1 221.2,55.5 C220.4,55.9 219,56.9 217.7,57.1 C213.3,57.8 213.2,55.6 213.2,55.6 L220.8,54.3"
          id="Shape"
          fill="#006E59"
        />
        <path
          d="M211.9,50.2 L202.3,47.2 C202.3,47.2 203.2,44.4 208.3,46 C210.8,46.8 212.9,49.1 214.2,49.9 C215.4,50.7 216.7,51.4 216.7,51.4 C216.7,51.4 215.2,51.3 211.7,51.7 C210.5,51.8 208.5,52.2 206.8,51.8 C201.3,50.4 202.2,47.7 202.2,47.7 L211.9,50.2"
          id="Shape"
          fill="#007A61"
        />
        <path
          d="M201.6,42 L190.6,47.7 C190.6,47.7 188.9,44.5 194.8,41.4 C197.6,39.9 201.5,40.1 203.3,39.7 C205.1,39.3 206.8,38.9 206.8,38.9 C206.8,38.9 205.4,40.1 202.7,43.5 C201.8,44.6 200.3,46.8 198.5,47.8 C192.5,51.3 191,48.2 191,48.2 L201.6,42"
          id="Shape"
          fill="#64826F"
        />
        <path
          d="M220.6,46.9 L212.8,45.5 C212.8,45.5 213.2,43.2 217.4,44 C219.4,44.4 221.3,46 222.4,46.5 C223.4,47 224.5,47.4 224.5,47.4 C224.5,47.4 223.3,47.5 220.6,48.1 C219.7,48.3 218.1,48.8 216.8,48.6 C212.4,48 212.9,45.9 212.9,45.9 L220.6,46.9"
          id="Shape"
          fill="#006139"
        />
        <path
          d="M212.1,83.4 L204.3,82 C204.3,82 204.7,79.7 208.9,80.5 C210.9,80.9 212.8,82.5 213.9,83 C214.9,83.5 216,83.9 216,83.9 C216,83.9 214.8,84 212.1,84.6 C211.2,84.8 209.6,85.3 208.3,85.1 C203.9,84.5 204.4,82.4 204.4,82.4 L212.1,83.4"
          id="Shape"
          fill="#006E59"
        />
        <path
          d="M214.8,37.4 L208.1,41.6 C208.1,41.6 206.9,39.6 210.5,37.4 C212.2,36.3 214.7,36.2 215.8,35.9 C216.9,35.5 218,35.2 218,35.2 C218,35.2 217.2,36.1 215.6,38.3 C215.1,39.1 214.3,40.5 213.1,41.3 C209.4,43.8 208.4,41.9 208.4,41.9 L214.8,37.4"
          id="Shape"
          fill="#00978E"
        />
        <path
          d="M36,158.9 C40.8,158.9 44.3,155.4 44.3,150.4 C44.3,145.3 40.7,141.9 36,141.9 C31.2,141.9 27.7,145.3 27.7,150.4 C27.7,155.4 31.2,158.9 36,158.9 M36,138.2 C42.7,138.2 48.2,143.3 48.2,150.4 C48.2,157.5 42.7,162.6 36,162.6 C29.3,162.6 23.8,157.5 23.8,150.4 C23.9,143.3 29.3,138.2 36,138.2"
          id="Shape"
          fill="#373636"
        />
        <polyline
          id="Shape"
          fill="#373636"
          points="97 158.6 97 162.1 80.7 162.1 80.7 138.6 96.8 138.6 96.8 142.1 84.4 142.1 84.4 148.2 94.3 148.2 94.3 151.5 84.4 151.5 84.4 158.6 97 158.6"
        />
        <path
          d="M126.2,138.6 L116.5,162.1 L112.6,162.1 L102.9,138.6 L107,138.6 L113.2,154.1 C113.9,156.1 114.5,157.9 114.5,157.9 L114.5,157.9 C114.5,157.9 115.1,156.1 115.8,154.1 L122,138.6 L126.2,138.6"
          id="Shape"
          fill="#373636"
        />
        <polyline
          id="Shape"
          fill="#373636"
          points="148.8 158.6 148.8 162.1 132.5 162.1 132.5 138.6 148.6 138.6 148.6 142.1 136.2 142.1 136.2 148.2 146.1 148.2 146.1 151.5 136.2 151.5 136.2 158.6 148.8 158.6"
        />
        <polyline
          id="Shape"
          fill="#373636"
          points="233.6 158.6 233.6 162.1 217.8 162.1 217.8 138.6 221.5 138.6 221.5 158.6 233.6 158.6"
        />
        <path
          d="M254.5,153.5 L251.5,146.2 C251,144.9 250.4,143.2 250.4,143.2 L250.4,143.2 C250.4,143.2 249.8,145 249.3,146.2 L246.3,153.5 L254.5,153.5 L254.5,153.5 Z M255.8,156.8 L244.8,156.8 L242.6,162.1 L238.6,162.1 L248.5,138.6 L252,138.6 L261.9,162.1 L257.9,162.1 L255.8,156.8 Z"
          id="Shape"
          fill="#373636"
        />
        <path
          d="M288,138.6 L288,162.1 L284.5,162.1 L276,150.6 C273.9,147.8 271.9,144.8 271.9,144.8 L271.9,144.8 C271.9,144.8 272,147.9 272,152.1 L272,162.1 L268.3,162.1 L268.3,138.6 L271.8,138.6 L280.4,150.2 C282.1,152.5 284.4,155.8 284.5,155.8 L284.5,155.8 C284.5,155.8 284.4,152.3 284.4,148.7 L284.4,138.7 L288,138.7"
          id="Shape"
          fill="#373636"
        />
        <polyline
          id="Shape"
          fill="#373636"
          points="313.8 138.6 313.8 142.1 306.2 142.1 306.2 162.1 302.5 162.1 302.5 142.1 294.9 142.1 294.9 138.6 313.8 138.6"
        />
        <path
          d="M332.6,145.5 C332.1,142.9 329.9,141.4 327.3,141.4 C324.7,141.4 322.9,142.7 322.9,144.5 C322.9,146.7 325.8,147.5 328.9,148.4 C332.3,149.5 336.4,151.1 336.4,155.5 C336.4,159.6 332.9,162.5 327.7,162.5 C322.7,162.5 319.4,159.6 318.4,155.5 L322,154.5 C322.4,156.9 324.5,159.1 327.9,159.1 C330.9,159.1 332.6,157.6 332.6,155.5 C332.6,152.6 329,152 325.7,150.9 C323,150 319.2,148.7 319.2,144.6 C319.2,140.9 322.7,138 327.5,138 C331.9,138 335.3,140.6 336.1,144.3 L332.6,145.5"
          id="Shape"
          fill="#373636"
        />
        <path
          d="M67.6,153 C70.6,151.9 72.3,149.5 72.3,146.2 C72.3,141.6 68.9,138.6 63.3,138.6 L55.6,138.6 L55.6,150.4 L52,150.4 L52,153.7 L55.5,153.7 L55.5,162.1 L59.2,162.1 L59.2,153.7 L63.2,153.7 C63.5,153.7 63.7,153.7 63.9,153.7 L68.9,162.1 L73.1,162.1 L67.6,153 L67.6,153 Z M63.7,150.4 L59.3,150.4 L59.3,142.1 L63.7,142.1 C66.7,142.1 68.4,143.8 68.4,146.2 C68.4,148.6 66.8,150.4 63.7,150.4 Z"
          id="Shape"
          fill="#373636"
        />
        <path
          d="M169.2,153 C172.2,151.9 173.9,149.5 173.9,146.2 C173.9,141.6 170.5,138.6 164.9,138.6 L157.2,138.6 L157.2,150.4 L153.7,150.4 L153.7,153.7 L157.2,153.7 L157.2,162.1 L160.9,162.1 L160.9,153.7 L164.9,153.7 C165.2,153.7 165.4,153.7 165.6,153.7 L170.6,162.1 L174.8,162.1 L169.2,153 L169.2,153 Z M165.4,150.4 L161,150.4 L161,142.1 L165.4,142.1 C168.4,142.1 170.1,143.8 170.1,146.2 C170.1,148.6 168.5,150.4 165.4,150.4 Z"
          id="Shape"
          fill="#373636"
        />
        <path
          d="M201.9,138.6 L194.1,138.6 L194.1,150.4 L190.4,150.4 L190.4,153.7 L194.1,153.7 L194.1,162.1 L197.8,162.1 L197.8,154 L201.9,154 C207.5,154 210.8,151.1 210.8,146.3 C210.8,141.5 207.5,138.6 201.9,138.6 L201.9,138.6 Z M201.8,150.5 L197.8,150.5 L197.8,142.1 L201.8,142.1 C205,142.1 206.9,143.6 206.9,146.3 C207,148.9 205.1,150.5 201.8,150.5 Z"
          id="Shape"
          fill="#373636"
        />
        <polyline
          id="Shape"
          fill="#373636"
          points="18.5 142.1 18.5 138.6 2.7 138.6 2.7 148.9 0 148.9 0 152.2 2.7 152.2 2.7 162.1 6.4 162.1 6.4 152.3 15.9 152.3 15.9 148.9 6.4 148.9 6.4 142.1 18.5 142.1"
        />
        <path
          d="M144.6,190.2 C144,190.9 142.5,192 140.5,192 C137,192 134.1,189.3 134.1,185.6 C134.1,181.9 136.9,179.2 140.5,179.2 C143,179.2 145,180.5 146.1,182.4 L144.1,182.9 C143.4,181.8 142,181.1 140.5,181.1 C137.9,181.1 136.1,182.9 136.1,185.6 C136.1,188.3 138,190.1 140.6,190.1 C142.9,190.1 144.2,188.8 144.6,187.8 L144.6,186.8 L141,186.8 L141,185.2 L146.3,185.2 L146.3,191.8 L144.6,191.8 C144.6,190.5 144.6,190.2 144.6,190.2 L144.6,190.2"
          id="Shape"
          fill="#373636"
        />
        <path
          d="M169,179.2 C172.5,179.2 175.4,181.9 175.4,185.6 C175.4,189.3 172.5,192 169,192 C165.5,192 162.6,189.3 162.6,185.6 C162.6,181.9 165.4,179.2 169,179.2 L169,179.2 Z M169,190.1 C171.5,190.1 173.4,188.3 173.4,185.6 C173.4,182.9 171.5,181.1 169,181.1 C166.5,181.1 164.6,182.9 164.6,185.6 C164.6,188.3 166.4,190.1 169,190.1 Z"
          id="Shape"
          fill="#373636"
        />
        <path
          d="M189.4,179.4 L189.4,186.5 C189.4,190.1 187.4,192 184.2,192 C181,192 179,190.1 179,186.5 L179,179.4 L181,179.4 L181,186.5 C181,189 182.1,190.2 184.2,190.2 C186.3,190.2 187.5,189 187.5,186.5 L187.5,179.4 L189.4,179.4"
          id="Shape"
          fill="#373636"
        />
        <path
          d="M197.8,179.4 L193.7,179.4 L193.7,185.7 L192.3,185.7 L192.3,187.5 L193.7,187.5 L193.7,191.7 L195.7,191.7 L195.7,187.4 L197.8,187.4 C200.7,187.4 202.5,185.9 202.5,183.4 C202.5,180.9 200.8,179.4 197.8,179.4 L197.8,179.4 Z M197.8,185.7 L195.7,185.7 L195.7,181.3 L197.8,181.3 C199.5,181.3 200.5,182.1 200.5,183.5 C200.5,184.8 199.5,185.7 197.8,185.7 Z"
          id="Shape"
          fill="#373636"
        />
        <path
          d="M156.9,187 C158.5,186.4 159.4,185.2 159.4,183.4 C159.4,181 157.6,179.4 154.7,179.4 L150.7,179.4 L150.7,185.6 L149.4,185.6 L149.4,187.3 L150.7,187.3 L150.7,191.7 L152.7,191.7 L152.7,187.3 L154.8,187.3 C154.9,187.3 155.1,187.3 155.2,187.3 L157.8,191.7 L160,191.7 L156.9,187 L156.9,187 Z M154.9,185.6 L152.6,185.6 L152.6,181.2 L154.9,181.2 C156.5,181.2 157.4,182.1 157.4,183.4 C157.4,184.6 156.6,185.6 154.9,185.6 Z"
          id="Shape"
          fill="#373636"
        />
      </g>
    </g>
  </svg>
);
export const Facebook = ({ extraClasses }) => (
  <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon">
        <circle id="Oval" fill="#52BD89" cx="24" cy="24" r="24" />
        <path
          d="M35.759999,16.4865727 C35.759999,14.461037 33.931312,12.6315789 31.905263,12.6315789 L16.486316,12.6315789 C14.460266,12.6315789 12.631579,14.461037 12.631579,16.4865727 L12.631579,31.905006 C12.631579,33.930541 14.460266,35.759999 16.486573,35.759999 L24.195789,35.759999 L24.195789,27.022596 L21.368982,27.022596 L21.368982,23.167859 L24.195789,23.167859 L24.195789,21.666054 C24.195789,19.075928 26.140632,16.7432981 28.532368,16.7432981 L31.64828,16.7432981 L31.64828,20.598035 L28.532368,20.598035 C28.191352,20.598035 27.793543,21.012034 27.793543,21.632132 L27.793543,23.167859 L31.64828,23.167859 L31.64828,27.022596 L27.793543,27.022596 L27.793543,35.759999 L31.905263,35.759999 C33.931312,35.759999 35.759999,33.930541 35.759999,31.905006 L35.759999,16.4865727 Z"
          id="Combined-Shape-path"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </svg>
);

export const Instagram = ({ extraClasses }) => (
  <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1">
    <g
      id="Footer"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-708.000000, -81.000000)"
    >
      <g id="Group-2" transform="translate(708.000000, 81.000000)">
        <circle id="Oval-2" fill="#52BD89" cx="24" cy="24" r="24" />
        <g
          id="instagram-logo"
          transform="translate(12.631579, 12.631579)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <path
            d="M16.7272272,0 L6.3754396,0 C2.86002434,0 0,2.86016099 0,6.37557626 L0,16.7273639 C0,20.2429158 2.86002434,23.1029402 6.3754396,23.1029402 L16.7272272,23.1029402 C20.2429158,23.1029402 23.1029402,20.2427792 23.1029402,16.7273639 L23.1029402,6.37557626 C23.1030768,2.86016099 20.2429158,0 16.7272272,0 Z M21.053272,16.7273639 C21.053272,19.1126534 19.1126534,21.0531353 16.7273639,21.0531353 L6.3754396,21.0531353 C3.99028671,21.053272 2.04980482,19.1126534 2.04980482,16.7273639 L2.04980482,6.37557626 C2.04980482,3.99042337 3.99028671,2.04980482 6.3754396,2.04980482 L16.7272272,2.04980482 C19.1125168,2.04980482 21.0531353,3.99042337 21.0531353,6.37557626 L21.0531353,16.7273639 L21.053272,16.7273639 Z"
            id="Shape"
          />
          <path
            d="M11.5514701,5.59870023 C8.26891264,5.59870023 5.59842692,8.26918595 5.59842692,11.5517434 C5.59842692,14.8341642 8.26891264,17.5045132 11.5514701,17.5045132 C14.8340275,17.5045132 17.5045132,14.8341642 17.5045132,11.5517434 C17.5045132,8.26918595 14.8340275,5.59870023 11.5514701,5.59870023 Z M11.5514701,15.4545718 C9.39931167,15.4545718 7.64823174,13.7037651 7.64823174,11.5516067 C7.64823174,9.39931167 9.39917502,7.64836839 11.5514701,7.64836839 C13.7037651,7.64836839 15.4547084,9.39931167 15.4547084,11.5516067 C15.4547084,13.7037651 13.7036285,15.4545718 11.5514701,15.4545718 Z"
            id="Shape"
          />
          <path
            d="M17.7541795,3.8606024 C17.3592504,3.8606024 16.9712907,4.02048717 16.6923806,4.30062716 C16.4121039,4.57940062 16.2509893,4.967497 16.2509893,5.3637926 C16.2509893,5.75885831 16.4122406,6.14681804 16.6923806,6.42695803 C16.971154,6.70573148 17.3592504,6.8669828 17.7541795,6.8669828 C18.1504751,6.8669828 18.5372049,6.70573148 18.8173449,6.42695803 C19.0974849,6.14681804 19.2573697,5.75872166 19.2573697,5.3637926 C19.2573697,4.967497 19.0974849,4.57940062 18.8173449,4.30062716 C18.5385714,4.02048717 18.1504751,3.8606024 17.7541795,3.8606024 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const Twitter = ({ extraClasses }) => (
  <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1">
    <g
      id="Footer"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-772.000000, -81.000000)"
    >
      <g
        id="twitter"
        transform="translate(772.000000, 81.000000)"
        fillRule="nonzero"
      >
        <circle id="Oval" fill="#52BD89" cx="24" cy="24" r="24" />
        <path
          d="M38.7692308,17.3919058 C37.7506514,17.836526 36.6549584,18.1372494 35.5058789,18.271553 C36.6791094,17.5795972 37.5794759,16.4847305 38.0044489,15.177981 C36.9066373,15.8190515 35.6901892,16.2841092 34.3966273,16.5347816 C33.3602525,15.4482567 31.8836515,14.7692308 30.2485859,14.7692308 C27.1114972,14.7692308 24.5671673,17.2738687 24.5671673,20.3620186 C24.5671673,20.8003823 24.6175879,21.2270675 24.7150393,21.636652 C19.9933055,21.4034975 15.8067072,19.1770599 13.0043429,15.7923577 C12.515391,16.6182 12.2349003,17.5795972 12.2349003,18.6043925 C12.2349003,20.5442878 13.2386501,22.2568679 14.7622821,23.2595573 C13.831409,23.2307779 12.9547698,22.9792714 12.1891405,22.5592597 C12.1887168,22.5830339 12.1887168,22.6068082 12.1887168,22.6301653 C12.1887168,25.3400126 14.1479143,27.6002346 16.746478,28.113675 C16.2702371,28.2421393 15.7673029,28.3101253 15.2499629,28.3101253 C14.8830371,28.3101253 14.5275512,28.2755067 14.1809631,28.2104403 C14.9037985,30.4318728 17.0015465,32.0489388 19.4882529,32.0944018 C17.5434612,33.5946821 15.0940406,34.4885104 12.431498,34.4885104 C11.9739,34.4885104 11.5205389,34.4622336 11.0769231,34.4100971 C13.5898989,35.9975496 16.5769972,36.9230769 19.7852679,36.9230769 C30.2354511,36.9230769 35.9503421,28.4010514 35.9503421,21.0097626 C35.9503421,20.7674321 35.944834,20.5259357 35.9338178,20.2865249 C37.0447641,19.4982208 38.0078385,18.5134664 38.7692308,17.3919058 Z"
          id="Shape"
          fill="#F1F2F2"
        />
      </g>
    </g>
  </svg>
);

export const ContactDocenten = ({ extraClasses }) => (
  <svg width="58px" height="37px" viewBox="0 0 58 37" version="1.1">
    <g
      id="Contact"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-524.000000, -899.000000)"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="np_teacher_763720_000000"
        transform="translate(525.000000, 900.000000)"
        stroke="#525051"
        strokeWidth="1.7"
      >
        <path
          d="M22.6647891,29.6543367 L18.5193345,27.9152654 C18.1226007,27.7484703 17.7663818,27.5051095 17.4668036,27.204349 C16.8784531,26.60826 16.5194982,25.7879761 16.5194982,24.8801506 L16.5194982,24.1282144 C18.99164,22.4520727 20.7243018,18.5473523 20.7243018,13.999965 C20.7243018,10.1336043 17.6313782,7 13.8152109,7 C10.0017382,7 6.90881455,10.1336043 6.90881455,13.997235 C6.90881455,18.5444823 8.64417091,22.4489928 11.1163127,24.1254844 L11.1163127,24.8774206 C11.1163127,25.7852461 10.7546633,26.605572 10.1690073,27.201619 C9.869436,27.5024005 9.51318255,27.7457543 9.11378182,27.9125354 L0,31.7406763 L0,35 L25.9090909,35 L38,14.000105 L35.4117855,12.2501137 L22.6647891,29.6543367 Z"
          id="Shape"
        />
        <path
          d="M52.4973925,0 L17.5000175,0 C15.5750079,0 14,1.59998222 14,3.55551605 L14,7.1110321 C17.8663993,7.1110321 20.997305,10.2943567 20.997305,14.2220642 C20.997305,18.8414618 19.2418362,22.8079244 16.7371537,24.5110165 L16.7371537,25.2748836 C16.7371537,26.1971134 17.1035635,27.0304552 17.6969285,27.6359596 C18.000443,27.9415135 18.3613858,28.1887286 18.7633138,28.358156 L22.9633348,30.1248208 L35.8748994,12.4446617 L38.4971825,14.2224198 L28.2897314,32 L52.4972525,32 C54.4249921,32 56,30.4000178 56,28.444484 L56,3.5558716 C56,1.60033777 54.4249921,0.000355551605 52.4972525,0.000355551605 L52.4973925,0 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export const ContactLeveranciers = ({ extraClasses }) => (
  <svg width="37px" height="42px" viewBox="0 0 37 42" version="1.1">
    <g
      id="Contact"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-285.000000, -894.000000)"
    >
      <g
        id="np_plant_715792_000000"
        transform="translate(286.000000, 895.000000)"
        fill="#525051"
        fillRule="nonzero"
        stroke="#525051"
        strokeWidth="0.6"
      >
        <path
          d="M30,0.0241904762 C28.3705238,0.146957143 26.8080476,0.585952381 25.4910476,1.34857143 C22.9296667,2.83109524 21.3597143,5.638 22.2619048,9.48857143 L18.0952381,12.2713333 L18.0952381,6.18514286 C18.106399,5.90984762 17.8329619,5.65871429 17.5595238,5.69409524 C17.3251476,5.72385714 17.1335571,5.94893333 17.1428571,6.18514286 L17.1428571,19.4141905 L12.9761905,16.6314286 C13.8783333,12.781 12.3084286,9.97428571 9.74704762,8.49142857 C8.43009524,7.7287619 6.86757143,7.28980952 5.23809524,7.16704762 C3.60861905,7.04428095 1.91219048,7.23215238 0.327619048,7.73252381 C0.136028571,7.79576667 -0.00348095238,7.99108095 0.000238095238,8.19383333 C0.0411609524,11.5160238 1.3897619,14.8733571 3.66095238,16.8990714 C5.87261905,18.8707857 9.03095238,19.4715952 12.4109524,17.4050238 L16.8752381,20.3812143 C16.9533619,20.437019 17.0482286,20.4686381 17.1430952,20.4705 L17.1430952,24.7562143 L9.04785714,24.7562143 C7.73647619,24.7562143 6.66690476,25.8257857 6.66690476,27.1371667 C6.66690476,28.3257857 7.55047619,29.3135 8.69071429,29.4883571 L9.88119048,38.6550238 C9.9909381,39.4232619 10.655,39.9943095 11.4288095,39.9943095 L23.8097619,39.9943095 C24.5835714,39.9943095 25.247619,39.4232619 25.357381,38.6550238 L26.5478571,29.4883571 C27.6880952,29.3135048 28.5716667,28.3257857 28.5716667,27.1371667 C28.5716667,25.8257857 27.5020952,24.7562143 26.1907143,24.7562143 L18.0954762,24.7562143 L18.0954762,13.3276429 C18.1903429,13.3257829 18.2852095,13.294161 18.3633333,13.2383571 L22.827619,10.2621667 C26.2074762,12.3287381 29.3657143,11.7279286 31.577619,9.75621429 C33.8488095,7.73054762 35.1974286,4.37288095 35.2383333,1.05097619 C35.2420533,0.84822381 35.1025429,0.652909524 34.9109524,0.589666667 C33.1717619,0.12277619 31.5869048,-0.0613809524 30.0004762,0.0241904762 L30,0.0241904762 Z M34.2410476,1.423 C34.1052571,4.36571429 32.8682857,7.33633333 30.9374762,9.05680952 C29.0624762,10.7271905 26.6294286,11.2815238 23.7203333,9.66690476 L26.934619,7.52404762 C27.1113286,7.4124381 27.1968952,7.17434286 27.1336524,6.97533333 C27.0704095,6.7763 26.8602143,6.63307143 26.6518905,6.64609048 C26.5607429,6.65167095 26.473319,6.68143286 26.3989143,6.73537619 L23.1399619,8.90799524 C22.4870571,5.60070952 23.7798667,3.43370952 25.9673429,2.16704286 C27.1354857,1.48994762 28.5677714,1.09004286 30.0744857,0.976566667 C31.4844381,0.892861905 33.0469619,1.09561429 34.2411524,1.42299524 L34.2410476,1.423 Z M5.16390476,8.11919048 C6.67061905,8.23265714 8.10290476,8.63257143 9.27104762,9.30966667 C11.4585714,10.5764286 12.7513333,12.7434286 12.0984286,16.050619 L8.83947619,13.878 C8.74647143,13.8091762 8.62742381,13.7775524 8.51209524,13.7887143 C8.11775238,13.8259167 7.96895238,14.4564762 8.3037619,14.6667143 L11.5180476,16.8095714 C8.60880952,18.4241429 6.17566667,17.8698571 4.30090476,16.1994762 C2.37009524,14.4788571 1.13314286,11.5082381 0.997333333,8.56566667 C2.47428571,8.18248095 3.78195238,8.04480952 5.164,8.1192381 L5.16390476,8.11919048 Z M9.04780952,25.7087143 L26.1906667,25.7087143 C26.9905238,25.7087143 27.6192381,26.3374286 27.6192381,27.1372857 C27.6192381,27.9278571 27.005381,28.551 26.2204286,28.5658571 L25.7144762,28.4914524 L25.6995952,28.5658571 L9.53864286,28.5658571 L9.5237619,28.4914524 L9.04757143,28.5658571 C8.24771429,28.5658571 7.619,27.9371429 7.619,27.1372857 C7.619,26.3374286 8.24771429,25.7087143 9.04757143,25.7087143 L9.04780952,25.7087143 Z M9.65790476,29.5182381 L25.5807619,29.5182381 L24.4200476,38.5210952 C24.3828452,38.7833714 24.0889476,39.0419524 23.8099524,39.0419524 L11.429,39.0419524 C11.149981,39.0419524 10.8560952,38.7833952 10.8189048,38.5210952 L9.65790476,29.5182381 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export const ContactSolliciteren = ({ extraClasses }) => (
  <svg
    width="40px"
    height="35px"
    viewBox="0 0 40 35"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Contact"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-654.000000, -898.000000)"
    >
      <g
        id="np_briefcase_693688_000000"
        transform="translate(654.000000, 898.000000)"
        fill="#525051"
        fillRule="nonzero"
      >
        <path
          d="M27.4324324,2.69547297 C27.4324324,1.2285 26.25,0.0460675676 24.783027,0.0460675676 L14.9466081,0.047915 C13.4796351,0.047915 12.2972027,1.23034743 12.2972027,2.69732041 L12.2972027,6.43305014 L-9.45945946e-05,6.43305014 L-9.45945946e-05,34.9537934 L39.7296351,34.9537934 L39.7296351,6.43305014 L27.4323378,6.43305014 L27.4324324,2.69547297 Z M14.0468243,2.69547297 C14.0468243,2.17444595 14.4717622,1.74952703 14.9927703,1.74952703 L24.7828378,1.74952703 C25.3038649,1.74952703 25.7287838,2.17446486 25.7287838,2.69547297 L25.7287838,6.4312027 L14.0468243,6.43305014 L14.0468243,2.69547297 Z M37.9802027,33.2022297 L1.74952703,33.2022297 L1.74952703,15.6558784 C5.29682432,17.2170676 15.5598649,21.5680405 19.8648649,21.5680405 C24.1698649,21.5680405 34.4329054,17.2170676 37.9802027,15.6558784 L37.9802027,33.2022297 Z M37.9802027,8.18290541 L37.9802027,13.7162162 C35.4730676,14.8986486 24.1216216,19.8166216 19.8648649,19.8166216 C15.6081081,19.8166216 4.25675676,14.8504054 1.74952703,13.7162162 L1.74952703,8.18290541 L37.9802027,8.18290541 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export const ContactStudenten = ({ extraClasses }) => (
  <svg width="29px" height="40px" viewBox="0 0 29 40" version="1.1">
    <g
      id="Contact"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-414.000000, -895.000000)"
    >
      <g
        id="np_student_565725_000000"
        transform="translate(414.000000, 895.000000)"
        fill="#525051"
        fillRule="nonzero"
        stroke="#525051"
        strokeWidth="0.3"
      >
        <path
          d="M28.7830303,35.9612121 L26.8701818,25.7672727 C26.5103333,23.852 24.6353333,22.2942424 22.6869697,22.2942424 L18.1746667,22.2942424 L14.7347879,26.5461212 L11.8110303,22.2918788 L6.40381818,22.2918788 C4.45545455,22.2918788 2.57806061,23.8496364 2.21824242,25.7649091 L0.305393939,35.9588485 C0.12310303,36.9318788 0.34564,37.8551515 0.930363636,38.5606667 C1.51508727,39.2661818 2.38393939,39.6544242 3.37351515,39.6544242 L25.7147273,39.6544242 C26.704303,39.6544242 27.5707879,39.2661636 28.1578788,38.5606667 C28.745,37.8575152 28.9675152,36.9318788 28.7828485,35.9612121 L28.7830303,35.9612121 Z M14.7842424,29.1242424 L16.1502424,31.9722424 L14.9239394,33.4660606 L13.7355152,32.0503636 L14.7842424,29.1242424 Z M27.2272727,37.7890909 C26.876897,38.2128606 26.3395152,38.4448485 25.7168485,38.4448485 L3.37321212,38.4448485 C2.75060606,38.4448485 2.21551515,38.2128424 1.86278788,37.7890909 C1.51241212,37.3676909 1.3822,36.7971515 1.49583636,36.184 L3.40868485,25.9900606 C3.662,24.6429697 5.03274545,23.5066061 6.40110909,23.5066061 L11.1714727,23.5066061 L14.0194727,27.6519394 L12.3551697,32.2968485 L14.9285636,35.3626667 L17.5729879,32.1429697 L15.4091697,27.6353939 L18.7495939,23.5066061 L22.681897,23.5066061 C24.0526242,23.5066061 25.4233515,24.6453333 25.6743212,25.9900606 L27.5871697,36.184 C27.7079091,36.7971515 27.5777,37.3653333 27.2273212,37.7890909 L27.2272727,37.7890909 Z"
          id="Shape"
        />
        <path
          d="M6.06060606,13.1321212 C6.06060606,17.8101818 9.86739394,21.6169697 14.5454545,21.6169697 C19.2235152,21.6169697 23.030303,17.8101818 23.030303,13.1321212 C23.030303,11.4181212 22.5094667,9.82248485 21.6193333,8.492 L22.4337576,8.19607273 L22.4148182,8.24578848 C22.4384927,8.25525818 24.9242727,9.28748545 25.6629394,14.8294248 L26.8632424,14.668443 C26.3045273,10.4709885 24.7846364,8.54844303 23.7760909,7.70844303 L27.5521515,6.33535212 L14.5454848,0.227473333 L1.53639394,6.33050364 L7.46918182,8.48959455 C6.58142424,9.82244303 6.06057576,11.4180794 6.06057576,13.13214 L6.06060606,13.1321212 Z M14.5454545,20.4048485 C10.5350303,20.4048485 7.27272727,17.1425455 7.27272727,13.1321212 C7.27272727,9.15484848 10.5350303,5.92121212 14.5454545,5.92121212 C18.5558788,5.92121212 21.8181818,9.15745455 21.8181818,13.1321212 C21.8181818,17.1425455 18.5558788,20.4048485 14.5454545,20.4048485 Z M4.69212121,6.19090909 L14.5454545,1.56733333 L24.3987879,6.19090909 L20.8287273,7.49060606 C19.275697,5.78606061 17.0384848,4.70890909 14.5481212,4.70890909 C12.0577576,4.70890909 9.82036364,5.78606061 8.26751515,7.49060606 L4.69212121,6.19090909 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export const ContactVerkoop = ({ extraClasses }) => (
  <svg width="34px" height="40px" viewBox="0 0 34 40" version="1.1">
    <g
      id="Contact"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-160.000000, -895.000000)"
    >
      <g
        id="Group-2"
        transform="translate(122.000000, 871.000000)"
        fill="#525051"
        fillRule="nonzero"
      >
        <g
          id="np_account_1404635_000000"
          transform="translate(38.000000, 24.000000)"
        >
          <path
            d="M34,39 C34,39.55078 33.55078,40 33,40 C32.44922,40 32,39.55078 32,39 C32,30.7148 25.2852,24 17,24 C8.7148,24 2,30.7148 2,39 C2,39.55078 1.55078,40 1,40 C0.44922,40 0,39.55078 0,39 C0,29.6094 7.6094,22 17,22 C26.3906,22 34,29.6094 34,39 Z M17,20 C11.4766,20 7,15.5234 7,10 C7,4.4766 11.4766,0 17,0 C22.5234,0 27,4.4766 27,10 C27,15.5234 22.5234,20 17,20 Z M17,18 C21.418,18 25,14.418 25,10 C25,5.582 21.418,2 17,2 C12.582,2 9,5.582 9,10 C9,14.418 12.582,18 17,18 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const TelephoneGreen = ({ extraClasses }) => (
  <svg width="11" height="11" viewBox="0 0 11 11">
    <path
      fill="#52BD89"
      fillRule="nonzero"
      d="M3.815 8.902s1.991 1.736 4.214 2.055c0 0 1.558.347 2.626-.926 0 0 .736-.536.058-1.39L9.039 6.99s-.404-.463-1.054-.057l-.995.984S4.248 6.499 3.15 4.025l.766-.768s.765-.68.014-1.447L2.256.16s-.592-.42-1.183.1c0 0-1.444 1.217-.982 3.258 0 0 .044 2.142 3.724 5.384z"
    />
  </svg>
);

export const HouseBlack = ({ extraClasses }) => (
  <svg width="12" height="12" viewBox="0 0 12 12">
    <path
      fill="#525051"
      fillRule="evenodd"
      d="M0 12V3.466L6 0l1.68 1.08V0h2.415l-.015 2.4L12 3.71V12H9.628V7.92H7.69V12z"
    />
  </svg>
);

export const MailBlack = ({ extraClasses }) => (
  <svg width="15" height="9" viewBox="0 0 15 9">
    <path
      fill="#525051"
      fillRule="nonzero"
      d="M1.103 0a1.44 1.44 0 0 0-.606.11l6.631 5.173c.27.125.474.125.744 0l6.63-5.174A1.377 1.377 0 0 0 13.92 0H1.103zM.051.656A1.469 1.469 0 0 0 0 1.05V7.7c0 .18.026.336.074.47l4.693-3.817L.051.656zm14.903 0l-4.721 3.697 4.693 3.817c.049-.137.074-.3.074-.487v-6.65c0-.139-.016-.265-.046-.377zM5.351 4.802L.589 8.673c.146.052.323.077.526.077h12.793c.192 0 .362-.027.503-.077L9.65 4.802c-.476.366-.96.752-1.435 1.11a1.652 1.652 0 0 1-1.43 0c-.478-.358-.958-.74-1.434-1.11z"
    />
  </svg>
);

export const MailGreen = ({ extraClasses }) => (
  <svg width="15" height="9" viewBox="0 0 15 9" fill="#52bd89">
    <path
      fill="#52bd89"
      fillRule="nonzero"
      d="M1.103 0a1.44 1.44 0 0 0-.606.11l6.631 5.173c.27.125.474.125.744 0l6.63-5.174A1.377 1.377 0 0 0 13.92 0H1.103zM.051.656A1.469 1.469 0 0 0 0 1.05V7.7c0 .18.026.336.074.47l4.693-3.817L.051.656zm14.903 0l-4.721 3.697 4.693 3.817c.049-.137.074-.3.074-.487v-6.65c0-.139-.016-.265-.046-.377zM5.351 4.802L.589 8.673c.146.052.323.077.526.077h12.793c.192 0 .362-.027.503-.077L9.65 4.802c-.476.366-.96.752-1.435 1.11a1.652 1.652 0 0 1-1.43 0c-.478-.358-.958-.74-1.434-1.11z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/images/index.js